import http from "./http";
import urlConfig from "./url.config";
import { isMobile } from "../utils/utils";
import { getCode } from "../utils/domain";

function encryptData(data) {
  const _data = window.reRsa(data);
  let params = {};
  params.data = _data.DES;
  params.headers = {
    Encryption: _data.RSA,
  };
  return params;
}

const Api = {
  status: (data) => {
    return http.get(urlConfig.status, { data });
  },
  getCaptcha: () => {
    return http.get(urlConfig.captcha);
  },
  login: (userinfo) => {
    const user = encryptData(userinfo);
    return http.post(urlConfig.login, user);
  },
  register: (userinfo) => {
    const data = getCode();
    userinfo.data.registerUrl = window.location.href;
    userinfo.data.affiliateCode = data.code || "";
    userinfo.data.domain = data.domain || "";
    userinfo.data.registerMethod = isMobile() ? "MOBILE" : "WEB";
    const user = encryptData(userinfo.data);
    return http.put(urlConfig.register, user);
  },
};
export default Api;
